export const actions = [
	{ id: 'set_deal', label: 'Set Deal' },
	{ id: 'set_recruiter', label: 'Set Recruiter' },
	{ id: 'set_study', label: 'Set Study' },
	{ id: 'engage_lead', label: 'Engage Lead' },
	{ id: 'text_lead', label: 'One-off Text' },
	{ id: 'wait', label: 'Wait' }
];

export const days = [
	{ id: null, label: 'Any Day or Time' },
	{ id: 'MTWRFSY', label: 'Any Day' },
	{ id: 'MTWRF', label: 'Weekdays' },
	{ id: 'SY', label: 'Weekends' }
];

export const delay = [
	{ id: 60 * 5, label: '5 minutes' },
	{ id: 60 * 10, label: '10 minutes' },
	{ id: 60 * 20, label: '20 minutes' },
	{ id: 60 * 60, label: '1 hour' },
	{ id: 60 * 60 * 12, label: '12 hours' },
	{ id: 60 * 60 * 24, label: '1 day' },
	{ id: 60 * 60 * 24 * 2, label: '2 days' },
	{ id: 60 * 60 * 24 * 3, label: '3 days' },
	{ id: 60 * 60 * 24 * 4, label: '4 days' },
	{ id: 60 * 60 * 24 * 7, label: '1 week' }
];

export const outcomes = [
	{ id: 'Abandoned Call' },
	{ id: 'Booked Appointment' },
	{ id: 'Cannot Leave Voicemail' },
	{ id: 'Disconnected' },
	{ id: 'Do Not Call' },
	{ id: 'Error' },
	{ id: 'Group Event' },
	{ id: 'Left Voicemail' },
	{ id: 'Needs Callback' },
	{ id: 'Non Mobile' },
	{ id: 'No Text Reply' },
	{ id: 'Outside of US' },
	{ id: 'Scheduled Callback' },
	{ id: 'Scheduled Immediate Callback' },
	{ id: 'Text Replied' }
];

export const times = [
	{ id: null, label: 'Any Time' },
	{ id: '07:00:00', label: '7 AM' },
	{ id: '08:00:00', label: '8 AM' },
	{ id: '09:00:00', label: '9 AM' },
	{ id: '10:00:00', label: '10 AM' },
	{ id: '11:00:00', label: '11 AM' },
	{ id: '12:00:00', label: '12 PM' },
	{ id: '13:00:00', label: '1 PM' },
	{ id: '14:00:00', label: '2 PM' },
	{ id: '15:00:00', label: '3 PM' },
	{ id: '16:00:00', label: '4 PM' },
	{ id: '17:00:00', label: '5 PM' },
	{ id: '18:00:00', label: '6 PM' },
	{ id: '19:00:00', label: '7 PM' },
	{ id: '20:00:00', label: '8 PM' },
	{ id: '21:00:00', label: '9 PM' },
	{ id: '22:00:00', label: '10 PM' }
];
